module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Ticket-c11c19276ad6b51e5eb0bd9e1f28cb40.svg";